import { Divider, Box, Text } from '@cad-arc';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { ASSIGNMENT_MODAL_COMMON_SIZE, ASSIGNMENT_MODAL_PADDING_TOP } from '../constants';
import { RadioChannelOption } from '@mark43/cad-api';

export function AssignmentModalDetailsRadioChannel({
    radioChannel,
    additionalRadioChannels,
}: {
    radioChannel?: RadioChannelOption;
    additionalRadioChannels?: RadioChannelOption[];
}) {
    if (!radioChannel) {
        return null;
    }

    return (
        <Box>
            <SectionTitle title="Radio Channel" />
            <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}>{radioChannel.label}</Text>
            <Box alignItems="left">
                {!!additionalRadioChannels?.length && (
                    <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}>Additional:</Text>
                )}
                {additionalRadioChannels?.map((additionalRadioChannel) => (
                    <Text
                        fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}
                        key={additionalRadioChannel.label}
                    >
                        {additionalRadioChannel.label}
                    </Text>
                ))}
            </Box>
            <Divider style={ASSIGNMENT_MODAL_PADDING_TOP} />
        </Box>
    );
}
